import { render } from "./ScenariosSection.vue?vue&type=template&id=35afd886&scoped=true"
const script = {}

import "./ScenariosSection.vue?vue&type=style&index=0&id=35afd886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35afd886"]])

export default __exports__